import { VisualItem, AcceptedCash, Order, Product, Money, VuState, PrintTask, DtoVuConfiguration, TicketUse, CreditCard, Ticket } from '../../../lib/lib';
import { ScreenSaverConfiguration } from '../../../lib/screen-saver-configuration';
import { Observable } from 'rxjs';
import { TouchTileColor } from '../../../lib/touch-tile/touch-tile-color';
import { TouchTileSwitch } from '../../../lib/touch-tile/touch-tile-switch';
import { RunningLightScenario } from '../../../lib/touch-tile/running-light-scenario';
import { CreditCardTerminalState } from '../../../lib/credit-card/credit-card-terminal-state';
import { DisplayConfiguration } from '../../../lib/display/configuration/display-configuration';
import { CIOBoardPinEvent } from '../../../lib/cioboard/cioboard-pin-event';
import { MoneyExchangeRules } from '../../../lib/money-exchange/money-exchange-rules';
export const API_PRINT = `api/print`;
export const API_SYSTEM_PRINT = `api/print/system-print`;
export const API_PRINT_TEMPLATE = `api/print/template-by-unique-name`;
export const API_SAVE_ORDER = `api/save-order`;
export const API_CANCEL_ORDER = `api/cancel-order`;
export const API_CIOBOARD_OUTPUT_PIN = `api/cioboard`;
export const API_UPDATE_ANGULAR_STATE = `api/update/angular/state`;


export interface IVuHttp {
  isUseProductionApi: boolean;

  getProducts(): Promise<Product[]>;
  getProductsByIds(productIds: number[]): Promise<Product[]>;
  getProduct(productId: number): Promise<Product>;
  getSubProduct(productId: number): Promise<Product>;
  getVisualItems(type: string): Promise<VisualItem[]>;

  getDisplayConfiguration(configurationId: number): Promise<DisplayConfiguration>;

  getVuState(): Promise<VuState>;
  getVuConfiguration(): Promise<DtoVuConfiguration>;
  getTicketUse(code: string): Promise<TicketUse[]>;

  saveOrder(order: Order): Promise<any>;
  cancelOrder(order: Order): Promise<any>;

  print(task: PrintTask): Promise<any>;
  printByTemplateTypeUniqueName(templateTypeUniqueName: string, language: string): Promise<any>;
  openFmcuApi(url: string, body: object): Promise<any>;
  printApi(): Promise<any>;

  getAcceptedCash(amount: Money): Promise<AcceptedCash>;
  getAcceptedCreditCards(): Promise<CreditCard[]>;

  beginCardPaymentTransaction(amount: Money): void;
  beginPaymentTransaction(amount: Money): void;
  commitPaymentTransaction(force: boolean): void;
  appendTransactionInfo(info: string): void;
  revertPaymentTransaction(): Promise<any>;
  revertCardTerminalTransaction(): Promise<any>;

  returnAmount(amount: Money): Promise<any>;

  barcodeLedEnable(value: boolean): void;
  rfidCardLedEnable(value: boolean): void;

  scanTicket(barcode: string): void;

  getTicketInfo(barcode: string): Observable<Ticket>;

  activateOneDayTicket(ticket_code: string): Observable<Ticket>;

  printTicket(ticket_code: string): Promise<any>;

  callStaff(): void;

  getScreenSaverConfiguration(): Promise<ScreenSaverConfiguration>;

  openEnter(): Observable<boolean>;
  closeEnter(): Observable<boolean>;

  demoPayment(): Observable<any>;

  changeTouchTileColor(touchTileColor: TouchTileColor[]): Observable<boolean>;
  changeTouchTileSwitch(touchTileSwitch: TouchTileSwitch[]): Observable<boolean>;
  setRunningLight(runningLightScenario: RunningLightScenario): Observable<boolean>;

  changeTouchTileManualMode(value: boolean): Observable<boolean>;

  switchLntBoard(enabled: boolean);

  getCreditCardTerminalState(): Observable<CreditCardTerminalState>;

  gateReadBarcode(barcode: string, baseUrl: string, openGateType: string, timeout: number): Observable<any>;

  changeServerLanguage(locale_id: string): void;

  writeLogMessages(messages: string[]): Promise<any>;

  canPayoutAmount(amount: Money): Promise<boolean>;

  howMuchCanPayoutAmount(amount: Money): Promise<Money>;

  cioBoardAction(pins: CIOBoardPinEvent[]): Promise<any>;

  updateAngularPingState(): Promise<boolean>;

  produceRfidCard(): Promise<any>;
  releaseRfidCard(): Promise<any>;
  startTakingRfidCard(): Promise<any>;
  stopTakingRfidCard(): Promise<any>;
  captureRfidCard(): Promise<any>;

  startTransaction(): Promise<any>;
  stopTransaction(): Promise<any>;

  isCardTerminalAvailable(): Observable<boolean>;

  getMoneyExchangeRules(): Observable<MoneyExchangeRules>;

  isMoneyExchangeTransactionExist(): Observable<boolean>;

  beginMoneyExchangeTransaction(acceptedCash: AcceptedCash): Observable<boolean>;

  rollbackMoneyExchangeTransaction(): Observable<boolean>;

  commitMoneyExchangeTransaction(): Observable<boolean>;

  moneyExchangePayoutMoney(payoutAcceptedCash: AcceptedCash): Observable<boolean>;

  beginUnrestrictedCashPaymentTransaction(): Observable<boolean>;
  commitUnrestrictedCashPaymentTransaction(): Observable<boolean>;
  resetUnrestrictedCashPaymentTransaction(): Observable<boolean>;
  getAcceptedCashWithoutRestrictions(): Observable<AcceptedCash>;

  getOrderCache(): Observable<any>;
}

export interface IVuHttpSimulator {
  setScreenSaverConfiguration(screenSaverConfiguration: ScreenSaverConfiguration): void;
}
